import { render, staticRenderFns } from "./RespondsStep.vue?vue&type=template&id=05f65029&scoped=true"
import script from "./RespondsStep.vue?vue&type=script&lang=js"
export * from "./RespondsStep.vue?vue&type=script&lang=js"
import style0 from "./RespondsStep.vue?vue&type=style&index=0&id=05f65029&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f65029",
  null
  
)

export default component.exports